var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-name" }, [
          _vm._v("Users\n            "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary waves-effect pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.addStation.apply(null, arguments)
                }
              }
            },
            [_vm._v("Add")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content CustomPadTop0" }, [
          _c(
            "div",
            { staticClass: "app-filter-good-table-container" },
            [
              _c("vue-good-table", {
                ref: "stationList",
                attrs: {
                  mode: "remote",
                  title: "User Location List",
                  totalRows: _vm.totalRecords,
                  columns: _vm.columns,
                  rows: _vm.rows,
                  "pagination-options": {
                    enabled: true,
                    mode: "pages",
                    pageLabel: "Page",
                    position: "bottom",
                    perPage: _vm.serverParams.perPage,
                    setCurrentPage: _vm.serverParams.setCurrentPage,
                    perPageDropdown: [25, 50, 100, 200, 500],
                    dropdownAllowAll: false
                  },
                  selectOptions: {
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: "custom-class",
                    selectionText: "rows selected",
                    clearSelectionText: "clear"
                  },
                  "search-options": {
                    enabled: false
                  }
                },
                on: {
                  "on-page-change": _vm.onPageChange,
                  "on-selected-rows-change": _vm.selectionChanged,
                  "on-column-filter": _vm.onColumnFilter,
                  "on-per-page-change": _vm.onPerPageChange,
                  "on-sort-change": _vm.onSortChange
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "pagination-bottom",
                      fn: function(props) {
                        return [
                          _c("div", { staticClass: "vgt-wrap__footer crm" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col-sm-12 col-md-2 PerPage" },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      title: "Select Per Page",
                                      name: "customPerPage",
                                      id: "customPerPage",
                                      label: "text",
                                      clearable: false,
                                      searchable: false,
                                      filterable: false,
                                      options: _vm.serverParams.perPageDropdown,
                                      placeholder: "Select Per Page"
                                    },
                                    on: {
                                      change: _vm.changedValueTask,
                                      input: function($event) {
                                        return _vm.changedValueTaskCustomPerPageTask()
                                      }
                                    },
                                    model: {
                                      value: _vm.serverParams.perPage,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.serverParams,
                                          "perPage",
                                          $$v
                                        )
                                      },
                                      expression: "serverParams.perPage"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mt-2 col-sm-12 col-md-2 RowsDisplay"
                                },
                                [
                                  _c("p", { staticClass: "pageRowCount" }, [
                                    _vm._v(
                                      _vm._s(_vm.paginationDisplayRowsTask) +
                                        " of " +
                                        _vm._s(_vm.totalRecords)
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-sm-12 col-md-6 Pagination"
                                },
                                [
                                  _c(
                                    "ul",
                                    { staticClass: "pagination" },
                                    [
                                      _c(
                                        "li",
                                        {
                                          staticClass: "FirstPage",
                                          attrs: { title: "First Page" }
                                        },
                                        [
                                          Number(_vm.serverParams.page) == 1
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "page-link",
                                                    attrs: {
                                                      href: "javascript:void(0)"
                                                    }
                                                  },
                                                  [_vm._v("1")]
                                                )
                                              ]
                                            : [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "page-link",
                                                    attrs: {
                                                      href: "javascript:void(0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.onPerticularPageClickTask(
                                                          1
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("1")]
                                                )
                                              ]
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass: "page-item PreviousPage",
                                          attrs: { title: "Previous Page" }
                                        },
                                        [
                                          Number(_vm.serverParams.page) == 1
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "page-link",
                                                    attrs: {
                                                      href:
                                                        "javascript:void(0)",
                                                      tabindex: "-1"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-angle-left"
                                                    })
                                                  ]
                                                )
                                              ]
                                            : [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "page-link",
                                                    attrs: {
                                                      href:
                                                        "javascript:void(0)",
                                                      tabindex: "-1"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.onPerticularPageClickTask(
                                                          Number(
                                                            _vm.serverParams
                                                              .page
                                                          ) - 1
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-angle-left"
                                                    })
                                                  ]
                                                )
                                              ]
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.pageNumberListTask() <
                                      _vm.displayPageTask
                                        ? [
                                            _vm._l(
                                              _vm.pageNumberListTask(),
                                              function(n, index) {
                                                return [
                                                  n ==
                                                  Number(_vm.serverParams.page)
                                                    ? _c(
                                                        "li",
                                                        {
                                                          staticClass:
                                                            "PagesClass page-item active",
                                                          attrs: {
                                                            title: "Page " + n,
                                                            id: "pageNumber" + n
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "page-link",
                                                              attrs: {
                                                                href:
                                                                  "javascript:void(0)"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(n) +
                                                                  "\n                                                    "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "li",
                                                        {
                                                          staticClass:
                                                            "PagesClass page-item",
                                                          attrs: {
                                                            title: "Page " + n,
                                                            id: "pageNumber" + n
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.onPerticularPageClickTask(
                                                                n
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "page-link",
                                                              attrs: {
                                                                href:
                                                                  "javascript:void(0)"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                        " +
                                                                  _vm._s(n) +
                                                                  "\n                                                    "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                ]
                                              }
                                            )
                                          ]
                                        : [
                                            Number(_vm.serverParams.page) <=
                                            _vm.pageCompareTask
                                              ? [
                                                  _vm._l(
                                                    _vm.displayPageTask,
                                                    function(n, index) {
                                                      return [
                                                        n ==
                                                        Number(
                                                          _vm.serverParams.page
                                                        )
                                                          ? _c(
                                                              "li",
                                                              {
                                                                staticClass:
                                                                  "PagesClass page-item active",
                                                                attrs: {
                                                                  title:
                                                                    "Page " + n,
                                                                  id:
                                                                    "pageNumber" +
                                                                    n
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "page-link",
                                                                    attrs: {
                                                                      href:
                                                                        "javascript:void(0)"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                            " +
                                                                        _vm._s(
                                                                          n
                                                                        ) +
                                                                        "\n                                                        "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "li",
                                                              {
                                                                staticClass:
                                                                  "PagesClass page-item",
                                                                attrs: {
                                                                  title:
                                                                    "Page " + n,
                                                                  id:
                                                                    "pageNumber" +
                                                                    n
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.onPerticularPageClickTask(
                                                                      n
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "page-link",
                                                                    attrs: {
                                                                      href:
                                                                        "javascript:void(0)"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                            " +
                                                                        _vm._s(
                                                                          n
                                                                        ) +
                                                                        "\n                                                        "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                      ]
                                                    }
                                                  )
                                                ]
                                              : Number(_vm.serverParams.page) >=
                                                _vm.pageNumberListTask() -
                                                  (_vm.pageCompareTask - 1)
                                              ? [
                                                  _vm._l(
                                                    _vm.pageNumberListTask(),
                                                    function(n, index) {
                                                      return [
                                                        n >
                                                        _vm.pageNumberListTask() -
                                                          _vm.displayPageTask
                                                          ? [
                                                              n ==
                                                              Number(
                                                                _vm.serverParams
                                                                  .page
                                                              )
                                                                ? _c(
                                                                    "li",
                                                                    {
                                                                      staticClass:
                                                                        "PagesClass page-item active",
                                                                      attrs: {
                                                                        title:
                                                                          "Page " +
                                                                          n,
                                                                        id:
                                                                          "pageNumber" +
                                                                          n
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          staticClass:
                                                                            "page-link",
                                                                          attrs: {
                                                                            href:
                                                                              "javascript:void(0)"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                                " +
                                                                              _vm._s(
                                                                                n
                                                                              ) +
                                                                              "\n                                                            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "li",
                                                                    {
                                                                      staticClass:
                                                                        "PagesClass page-item",
                                                                      attrs: {
                                                                        title:
                                                                          "Page " +
                                                                          n,
                                                                        id:
                                                                          "pageNumber" +
                                                                          n
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.onPerticularPageClickTask(
                                                                            n
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a",
                                                                        {
                                                                          staticClass:
                                                                            "page-link",
                                                                          attrs: {
                                                                            href:
                                                                              "javascript:void(0)"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                                " +
                                                                              _vm._s(
                                                                                n
                                                                              ) +
                                                                              "\n                                                            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                            ]
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  )
                                                ]
                                              : [
                                                  _vm._l(
                                                    _vm.pageNumberListTask(),
                                                    function(n, index) {
                                                      return n >=
                                                        Number(
                                                          _vm.serverParams.page
                                                        ) -
                                                          (_vm.pageCompareTask -
                                                            1) &&
                                                        n <=
                                                          Number(
                                                            _vm.serverParams
                                                              .page
                                                          ) +
                                                            (_vm.pageCompareTask -
                                                              1)
                                                        ? [
                                                            n ==
                                                            Number(
                                                              _vm.serverParams
                                                                .page
                                                            )
                                                              ? _c(
                                                                  "li",
                                                                  {
                                                                    staticClass:
                                                                      "PagesClass page-item active",
                                                                    attrs: {
                                                                      title:
                                                                        "Page " +
                                                                        n,
                                                                      id:
                                                                        "pageNumber" +
                                                                        n
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "page-link",
                                                                        attrs: {
                                                                          href:
                                                                            "javascript:void(0)"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                            " +
                                                                            _vm._s(
                                                                              n
                                                                            ) +
                                                                            "\n                                                        "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "li",
                                                                  {
                                                                    staticClass:
                                                                      "PagesClass page-item",
                                                                    attrs: {
                                                                      title:
                                                                        "Page " +
                                                                        n,
                                                                      id:
                                                                        "pageNumber" +
                                                                        n
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.onPerticularPageClickTask(
                                                                          n
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "page-link",
                                                                        attrs: {
                                                                          href:
                                                                            "javascript:void(0)"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                            " +
                                                                            _vm._s(
                                                                              n
                                                                            ) +
                                                                            "\n                                                        "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                          ]
                                                        : _vm._e()
                                                    }
                                                  )
                                                ]
                                          ],
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass: "page-item NextPage",
                                          attrs: { title: "Next Page" }
                                        },
                                        [
                                          Number(_vm.serverParams.page) ==
                                          _vm.pageNumberListTask()
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "page-link",
                                                    attrs: {
                                                      href: "javascript:void(0)"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-angle-right"
                                                    })
                                                  ]
                                                )
                                              ]
                                            : [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "page-link",
                                                    attrs: {
                                                      href: "javascript:void(0)"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.onPerticularPageClickTask(
                                                          Number(
                                                            _vm.serverParams
                                                              .page
                                                          ) + 1
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-angle-right"
                                                    })
                                                  ]
                                                )
                                              ]
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        {
                                          staticClass: "LastPage",
                                          attrs: { title: "Last Page" }
                                        },
                                        [
                                          Number(_vm.serverParams.page) ==
                                          _vm.pageNumberListTask()
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "page-link",
                                                    attrs: {
                                                      href:
                                                        "javascript:void(0)",
                                                      tabindex: "-1"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.pageNumberListTask()
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            : [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "page-link",
                                                    attrs: {
                                                      href:
                                                        "javascript:void(0)",
                                                      tabindex: "-1"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.onPerticularPageClickTask(
                                                          _vm.pageNumberListTask()
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.pageNumberListTask()
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                        ],
                                        2
                                      )
                                    ],
                                    2
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                },
                                [
                                  _c("p", { staticClass: "pageJumpLabel" }, [
                                    _vm._v("Page : ")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6"
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.jumpToPageTask,
                                        expression: "jumpToPageTask"
                                      }
                                    ],
                                    staticClass: "form-control form-control-sm",
                                    attrs: {
                                      type: "text",
                                      name: "jumpToPageTask",
                                      id: "jumpToPageTask",
                                      placeholder: "Page"
                                    },
                                    domProps: { value: _vm.jumpToPageTask },
                                    on: {
                                      keyup: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.jumpToPageInTask.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.jumpToPageTask = $event.target.value
                                      }
                                    }
                                  })
                                ]
                              )
                            ])
                          ])
                        ]
                      }
                    },
                    {
                      key: "selected-row-actions",
                      fn: function(computed) {
                        return _c("div", {}, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(computed.selectedRows) +
                              "\n                        "
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { id: "deleteMultiple" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "Change Control(" +
                                  _vm._s(_vm.selectedRows) +
                                  ")"
                              )
                            ]
                          )
                        ])
                      }
                    },
                    _vm._l(_vm.rows, function(row, key) {
                      return {
                        key: "table-row",
                        fn: function(props) {
                          return [
                            _c("div", { key: key }, [
                              props.column.field == "action"
                                ? _c(
                                    "div",
                                    { staticClass: "table-action" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "btn btn-primary btn-sm",
                                          attrs: {
                                            title: "Update Location",
                                            to: {
                                              name: "UpdateUserLocation",
                                              params: { id: props.row.id }
                                            }
                                          }
                                        },
                                        [_vm._v("Update")]
                                      ),
                                      _vm._v(" "),
                                      props.row.status == "active"
                                        ? [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-success btn-sm",
                                                attrs: {
                                                  title: "User Status",
                                                  type: "button"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.changeStatus(
                                                      props.row.id,
                                                      props.row.status
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Active")]
                                            )
                                          ]
                                        : [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-danger btn-sm",
                                                attrs: {
                                                  title: "User Status",
                                                  type: "button"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.changeStatus(
                                                      props.row.id,
                                                      props.row.status
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Inactive")]
                                            )
                                          ]
                                    ],
                                    2
                                  )
                                : _c("div", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          props.formattedRow[props.column.field]
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                            ])
                          ]
                        }
                      }
                    })
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c89a58e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c89a58e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListUserLocation.vue
// module id = null
// module chunks = 